
<div class="displayTable">
  <div class="displayTableCell">

    <div class="authBlock">
      <h3>Angular Stripe Checkout Example</h3>



      <div class="col-md-12 mb-2">
        <button (click)="makePayment(99.99)" class="btn-primary btn-primary btn-block">One time payment of $99.99 to access 1 assessment</button>
      </div>
      <div class="col-md-12 mb-2">
        <button (click)="makePayment(49.99)" class="btn-primary btn-primary btn-block">Monthly Subscription payment of $49.99 - unlimited assessments</button>
      </div>
      <div class="col-md-12">
        <button (click)="makePayment(509)" class="btn-primary btn-primary btn-block">Yearly subscription payment of $509 (15% Savings) - unlimited assessments</button>
      </div>


      <br/>
      <div class="formGroup">
        <input type="button" class="btn btnPrimary" (click) = "authService.goToSignIn()" value="Sign In">
    
      </div>

    </div>




  </div>


</div>